import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "breadcrumb" };
const _hoisted_2 = {
    key: 1,
    class: "current"
};
import { ref, computed, watch } from 'vue';
import { useRoute } from 'vue-router';
import { getArticleDetail } from '@/api/article';
import { getProjectDetail } from '@/api/project';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Breadcrumb',
    setup(__props) {
        /**
         * 面包屑导航组件
         * 显示当前页面路径
         */
        const route = useRoute();
        const dynamicTitle = ref('');
        // 处理动态标题（文章详情/项目详情）
        async function loadDynamicTitle() {
            dynamicTitle.value = '';
            // 如果是文章详情页，获取文章标题
            if (route.name === 'ArticleDetail' && route.params.id) {
                try {
                    const article = await getArticleDetail(parseInt(route.params.id));
                    if (article && article.title) {
                        dynamicTitle.value = article.title;
                    }
                }
                catch (error) {
                    console.error('获取文章标题失败', error);
                }
            }
            // 如果是项目详情页，获取项目名称
            else if (route.name === 'ProjectDetail' && route.params.id) {
                try {
                    const project = await getProjectDetail(parseInt(route.params.id));
                    if (project && project.name) {
                        dynamicTitle.value = project.name;
                    }
                }
                catch (error) {
                    console.error('获取项目名称失败', error);
                }
            }
        }
        const breadcrumbItems = computed(() => {
            const items = [];
            const matched = route.matched;
            matched.forEach((record, index) => {
                if (record.meta && record.meta.title) {
                    // 跳过首页（已经在最前面硬编码为博客）
                    if (record.path === '/') {
                        return;
                    }
                    // 如果是一级路由下的详情页，先添加列表这一级
                    if (route.name === 'ArticleDetail' && matched.length === 1) {
                        items.push({
                            title: '文章列表',
                            path: '/article'
                        });
                    }
                    if (route.name === 'ProjectDetail' && matched.length === 1) {
                        items.push({
                            title: '项目展示',
                            path: '/projects'
                        });
                    }
                    // 处理当前项：详情页最后一个标题使用动态标题
                    let title = record.meta.title;
                    let isLink = index !== matched.length - 1;
                    // 文章详情或项目详情使用动态标题
                    if ((route.name === 'ArticleDetail' || route.name === 'ProjectDetail') &&
                        (matched.length === 1 || index === matched.length - 1) &&
                        dynamicTitle.value) {
                        title = dynamicTitle.value;
                        isLink = false;
                    }
                    if (isLink) {
                        items.push({
                            title,
                            path: record.path
                        });
                    }
                    else {
                        items.push({
                            title,
                            path: null
                        });
                    }
                }
            });
            return items;
        });
        // 监听路由变化重新加载
        watch(() => route.path, () => {
            loadDynamicTitle();
        });
        // 初始加载
        loadDynamicTitle();
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_router_link, { to: "/" }, {
                    default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                            _createTextVNode("博客", -1 /* CACHED */)
                        ]))]),
                    _: 1 /* STABLE */
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadcrumbItems.value, (item, index) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "separator" }, "/", -1 /* CACHED */)),
                        (item.path)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: item.path
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.title), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(item.title), 1 /* TEXT */))
                    ], 64 /* STABLE_FRAGMENT */));
                }), 128 /* KEYED_FRAGMENT */))
            ]));
        };
    }
});
